
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ML } from '../comment/ML';

@Injectable({ providedIn: 'root' })
export class Sendgridservice {
  constructor(private http: HttpClient) {
  }

  // CREATE MAILING LOG AND SEND MAIL NOTIFICATION
  sendMail(ml: ML) {
    let upd = JSON.stringify(ml);
    let mailingUrl = environment.appURL + "/mailinglogs/"
    return this.http.post(mailingUrl, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) }).pipe(tap(_ => { }), catchError(this.handleError<any>('sendMail')));
  }

  // ERROR HANDLER
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
